import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FlexBoxFullWHColumn } from '../../components/layout/layout.styles';
import LoginForm from '../../components/login-form/login-form.component';
import { HOME_PAGE_ROUTE } from '../../constants/routes.constants';
import { selectAccessToken } from '../../store/auth/auth.selector';

const LoginPage = () => {
    const accessToken = useSelector(selectAccessToken);
    const navigate = useNavigate();

    useEffect(() => {
        if (accessToken) {
            navigate(HOME_PAGE_ROUTE);
        }
    }, [accessToken, navigate]);

    return (
        <FlexBoxFullWHColumn sx={{ justifyContent: 'center' }}>
            {!accessToken && <LoginForm />}
        </FlexBoxFullWHColumn>
    );
};

export default LoginPage;
